export default __webpack_public_path__ + "static/road-to-thailand-bg-main-23d08b2918ec42c6c63551917831c477.png";